import classNames from 'classnames'
import React from 'react'

type WidgetWrapperProps = {
    children: React.ReactNode,
    title:string,
  className?:string,
    titleStyle?:string,
}
export default function WidgetWrapper({children, title, className, titleStyle}:WidgetWrapperProps) {
  return (
    <div
      className={classNames(
        "rounded-2xl p-5 md:p-6 flex-1 border border-white/60 dark:border-white/10 bg-white/85 dark:bg-slate-900/70 backdrop-blur-sm shadow-sm flex flex-col items-start w-full gap-4 overflow-hidden",
        className,
      )}
    >
        <div className={classNames(titleStyle,"")}>
            <span>{title}</span>
        </div>
        <div className="flex-1 min-h-0 w-full">
            {children}
        </div>
    </div>
  )
}
